import React from "react";
import ConfirmationDialog from "./ConfirmationDialog";

const ConfirmDialog = ({ handler, ...props }) => {
  const { confirm, closeConfirm, cancelConfirm } = handler;

  return (
    <ConfirmationDialog
      visible={confirm.open}
      title={confirm.title}
      message={confirm.message}
      onConfirm={closeConfirm}
      onCancel={cancelConfirm}
      confirmButtonText={confirm.confirmButtonText || "Discard"}
      declineButtonText={confirm.declineButtonText || "Cancel"}
      {...props}
    />
  );
};

export default ConfirmDialog;
